import {
  isBriefTabInShellPath,
  isInvestTabInShellPath,
  isPlanTabInShellPath,
  isTrackerTabInShellPath,
} from "@utils/bridge/shellTabPathPolicy";

import { I18nUtil } from "@utils/i18n";
import { ROUTER_PATH } from "@/src/config/router";
import Translations from "@translate/components/Menu/sideMenuNavConfig";
import { normalizePathname } from "@/src/utils/routeNormalizer";
import { resolveSideMenuOspIcon } from "./sideMenuNavIcons";

const I18n = I18nUtil.createScoped(Translations);

export type SideMenuNavTier = "primary" | "secondary";

export type SideMenuNavAction = "goal" | "missions";

export interface SideMenuNavItemConfig {
  id: string;
  labelKey: string;
  label: string;
  closeLabelKey?: string;
  closeLabel?: string;
  /** OspIcons name; from Figma layer via sideMenuNavIcons.ts */
  icon: string;
  resolveHref: (ctx: { isLoggedIn: boolean; ownerId?: string }) => string;
  isActive: (pathname: string) => boolean;
  tier: SideMenuNavTier;
  trackingScope: string;
  action?: SideMenuNavAction;
}

export const resolveBriefHref = (_isLoggedIn: boolean): string =>
  ROUTER_PATH.NEWS;

// 隐藏 News（V3.0.3）— 保留函数，后续可能恢复
// const isNewsOthersActive = (pathname: string): boolean => {
//   const normalized = normalizePathname(pathname);
//   const isNewsPath =
//     normalized.startsWith(`${ROUTER_PATH.NEWS}/`) ||
//     normalized === ROUTER_PATH.NEWS;
//
//   if (!isNewsPath) {
//     return false;
//   }
//
//   if (isBriefTabInShellPath(pathname)) {
//     return false;
//   }
//
//   return true;
// };

const isDiscoverOthersActive = (pathname: string): boolean => {
  const normalized = normalizePathname(pathname);
  return normalized.startsWith(ROUTER_PATH.DISCOVER);
};
// const isDeskListActive = (pathname: string): boolean => {
//   const normalized = normalizePathname(pathname);
//   return normalized.startsWith(ROUTER_PATH.DESK_LIST);
// };

export const PRIMARY_SIDE_MENU_NAV: () => SideMenuNavItemConfig[] = () => [
  {
    id: "brief",
    labelKey: "Brief",
    label: I18n.t("Brief"),
    icon: resolveSideMenuOspIcon("brief"),
    resolveHref: () => ROUTER_PATH.BRIEF,
    isActive: isBriefTabInShellPath,
    tier: "primary",
    trackingScope: "menu-guide-brief",
  },
  {
    id: "invest",
    labelKey: "Invest",
    label: I18n.t("Invest"),
    icon: resolveSideMenuOspIcon("invest"),
    resolveHref: () => ROUTER_PATH.INVEST,
    isActive: isInvestTabInShellPath,
    tier: "primary",
    trackingScope: "menu-guide-invest",
  },
  {
    id: "plan",
    labelKey: "Plan",
    label: I18n.t("Plan"),
    icon: resolveSideMenuOspIcon("plan"),
    resolveHref: () => ROUTER_PATH.PLAN,
    isActive: isPlanTabInShellPath,
    tier: "primary",
    trackingScope: "menu-guide-plan",
  },
  {
    id: "track",
    labelKey: "Track",
    label: I18n.t("Track"),
    icon: resolveSideMenuOspIcon("track"),
    resolveHref: () => ROUTER_PATH.DESK,
    isActive: isTrackerTabInShellPath,
    tier: "primary",
    trackingScope: "menu-guide-track",
  },
];

export const OTHERS_SIDE_MENU_NAV: () => SideMenuNavItemConfig[] = () => [
  // {
  //   id: "desk",
  //   labelKey: "Desk",
  //   label: I18n.t("Desk"),
  //   icon: resolveSideMenuOspIcon("desk"),
  //   resolveHref: () => ROUTER_PATH.DESK_LIST,
  //   isActive: isDeskListActive,
  //   tier: "secondary",
  //   trackingScope: "menu-guide-desk",
  // },
  // 隐藏 News（V3.0.3）— 保留代码，后续可能恢复
  // {
  //   id: "news",
  //   labelKey: "News",
  //   label: I18n.t("News"),
  //   icon: resolveSideMenuOspIcon("news"),
  //   resolveHref: ({ isLoggedIn }) => resolveBriefHref(isLoggedIn),
  //   isActive: isNewsOthersActive,
  //   tier: "secondary",
  //   trackingScope: "menu-guide-news",
  // },
  {
    id: "discover",
    labelKey: "Discover",
    label: I18n.t("Discover"),
    icon: resolveSideMenuOspIcon("discover"),
    resolveHref: () => ROUTER_PATH.DISCOVER_US_STOCKS,
    isActive: isDiscoverOthersActive,
    tier: "secondary",
    trackingScope: "menu-guide-discover",
  },
  {
    id: "missions",
    labelKey: "Missions",
    label: I18n.t("Missions"),
    closeLabelKey: "Tasks",
    icon: resolveSideMenuOspIcon("missions"),
    resolveHref: ({ ownerId }) =>
      ownerId
        ? `${ROUTER_PATH.AURA_PROFILE}/${ownerId}`
        : ROUTER_PATH.AURA_PROFILE,
    isActive: (pathname: string) => {
      const normalized = normalizePathname(pathname);
      return normalized.startsWith(ROUTER_PATH.AURA_PROFILE);
    },
    tier: "secondary",
    trackingScope: "menu-guide-missions",
    action: "missions",
  },
  {
    id: "subscriptions",
    labelKey: "Subscriptions",
    label: I18n.t("Subscriptions"),
    icon: resolveSideMenuOspIcon("subscriptions"),
    resolveHref: () => ROUTER_PATH.MEMBER,
    isActive: (pathname: string) => {
      const normalized = normalizePathname(pathname);
      return normalized.startsWith("/member");
    },
    tier: "secondary",
    trackingScope: "menu-guide-subscriptions",
  },
];
